function getServerUrl(req) {
  if (req) {
    const forwardedProto = req.headers["x-forwarded-proto"];
    const protocol = forwardedProto ? String(forwardedProto).split(",")[0]?.trim() || "https" : "https";
    const host = req.headers.host;
    const url = req.url || "";
    return `${protocol}://${host}${url}`;
  }
  if (typeof window !== "undefined") {
    return window.location.href;
  }
  return "";
}
export {
  getServerUrl as g
};
//# sourceMappingURL=get-server-url.js.map
